import React from 'react';
import {Card, CardContent} from '@mui/material';
import classNames from './Package.module.css'
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

type PackageProps = {
    description: string,
    name: string,
    onClick: () => void,
    price: number,
}

export const Package = (props: PackageProps) => {
    const {description, name, onClick, price} = props

    return (
        <Card className={classNames.root} variant="outlined">
            <CardContent>
                <Typography variant="h6">{name}</Typography>

                <Typography className={classNames.description} component="div">
                    <p dangerouslySetInnerHTML={{__html: description}} />
                </Typography>

                <div className={classNames.buttonPriceContainer}>
                    <Typography>
                        {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'SAR' }).format(price)}
                    </Typography>
                    <Button variant="contained" onClick={onClick}>Select Package</Button>
                </div>
            </CardContent>
        </Card>
    )
}
